/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileSubscription } from '../../models/profile-subscription';

export interface CreateOneDaySubscriptionAfterPurchase$Params {

/**
 * ID of profile
 */
  id: number;
}

export function createOneDaySubscriptionAfterPurchase(http: HttpClient, rootUrl: string, params: CreateOneDaySubscriptionAfterPurchase$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileSubscription>> {
  const rb = new RequestBuilder(rootUrl, createOneDaySubscriptionAfterPurchase.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileSubscription>;
    })
  );
}

createOneDaySubscriptionAfterPurchase.PATH = '/rest/profile/{id}/purchase/one-day-subsiption-after-purchase';
